import React from 'react';
import { IComponentImage } from '../../component';
import Image from './Image';

const AllForImage = function(props: IComponentImage) {
  return (
    <div className="all-for-image">
      <Image {...props} />
    </div>
  );
};

export default AllForImage;
